import { createSelector } from '@reduxjs/toolkit';

const selectRoot = state => state?.trailerDetails;

export const selectTrailers = createSelector(selectRoot, state => state?.trailers);
export const selectItems = createSelector(selectTrailers, state => state?.items ?? []);
